<template>
    <div class="marginCon">
        <Card :styles="{ 'top': '20%', 'min-width': '700px' }">
            <p slot="title">{{ $t('setting.title') }}</p>
            <ModelBox  :showModel="showModel"  :type="2" :editFormData="editFormData"></ModelBox>
        </Card>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import ModelBox from '../home/component/addModelNew.vue';
import { mapMutations, mapState } from 'vuex'
export default {
    name: "settingModel",
    components: {
        // ImgUpload,
        ModelBox
    },
    data() {
        return {
            showModel: true,
            editFormData: {},
            type: 2
        }
    },

    computed: {
        ...mapState(['local', 'selectId', 'uInfo']),
        selectObj() {
            return {
                languageList: [
                    { id: 'zh_CN', val: this.$t('zh_CN') },
                    { id: 'en_US', val: this.$t('en_US') }
                ]
            }
        },
        roleType() {
            let res = '2'
            if (this.$store.state.uInfo && this.$store.state.uInfo.roleType) {
                res = this.$store.state.uInfo.roleType
            }
            return res
        },

    },
    created() {
    
    },

    methods: {
    
    }
}
</script>
<style lang="less" scoped>


.logoCon /deep/ .ivu-form-item-content {
    margin-left: 0px !important;
}

/deep/ .ivu-form .ivu-form-item-label {
    width: 160px !important;
}

/deep/ .ivu-form-item-content {
    margin-left: 160px !important;
}
</style>
